import { Download } from "@mui/icons-material";
import { Box, Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import React, { useState } from "react";
import companyService from "../../services/companyService";
import policyService from "../../services/policyService";
import PolicyUploadModal from "./PolicyUploadModal.jsx";

const PolicyCustomTable = (props) => {
	
	let [ showUploadPolicy, setShowUploadPolicy ] = useState(false);
	let [ showUploadPolicyLoading, setShowUploadPolicyLoading ] = useState(false);
	
	const handleUploadClick = () => {
		setShowUploadPolicy(true);
	};
	
	const handleUploadClose = () => {
		setShowUploadPolicy(false);
	};
	
	const handleUploadSubmit = async (policy) => {
		try {
			await policyService.addCompanyPolicy(policy);
			await policyService.getCompanyPolicies(companyService.selectedCompany.id);
			setShowUploadPolicy(false);
			setShowUploadPolicyLoading(false);
		}
		catch (e) {
			console.log(e.message);
			setShowUploadPolicy(false);
			setShowUploadPolicyLoading(false);
		}
	};

	const handleRowClick = (policy) => {
		policyService.downloadCompanyPolicy(policy);
	};

	return (
		<Box sx={{width: "100%", margin: "auto"}}>
			<TableContainer component={Paper} sx={{ width: "100%" }}>
				<Table>
					<TableHead>
						<TableRow>
							<TableCell sx={{ textAlign: "left", width: "75%" }}>Name</TableCell>
							<TableCell sx={{ textAlign: "center", width: "10%" }}>Type</TableCell>
							<TableCell sx={{ textAlign: "center", width: "10%" }}>Category</TableCell>
							<TableCell sx={{ textAlign: "center", width: "5%" }}></TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{policyService.companyPolicies? policyService.companyPolicies.map((policy) => (
						<TableRow key={`policy_${policy.id}`}>
							<TableCell sx={{ textAlign: "left" }}>
								<Button
									onClick={() => { handleRowClick(policy) }}
									sx={{ width: "100%", justifyContent: "flex-start" }}
								>
									{`${policy.name}`}
								</Button>
							</TableCell>
							<TableCell sx={{ textAlign: "center" }}>{policy.type}</TableCell>
							<TableCell sx={{ textAlign: "center" }}>{policy.category}</TableCell>
							<TableCell sx={{ textAlign: "center" }}>
								<Button
									onClick={() => { handleRowClick(policy) }}
									sx={{ width: "100%", justifyContent: "center" }}
								>
									<Download/>
								</Button>
							</TableCell>
						</TableRow>
						)):<TableRow></TableRow>}
					</TableBody>
				</Table>
			</TableContainer>
			<Box justifyContent="flex-right">
				<Button
					onClick={handleUploadClick}
					sx={{ }}
				>
					+ Upload
				</Button>
			</Box>
			<PolicyUploadModal
				loading={showUploadPolicyLoading}
				open={showUploadPolicy}
				onClose={handleUploadClose}
				onSubmit={handleUploadSubmit}
			/>
		</Box>
	)
}

export default PolicyCustomTable;